export default __webpack_public_path__ + "static/media/nft-bank-ai.664d2830.jpg";